module.exports = __webpack_public_path__ + "static/media/nham24-icon-gif.dc3bbc37.gif";